import { BehaviorSubject } from "rxjs";

import { type WorkspaceContextState } from "@/data_source/models/APIWorkspaceContext";

import { Store } from "./store";

export class WorkspaceContextStore extends Store<WorkspaceContextState> {
  protected _observable: BehaviorSubject<WorkspaceContextState | null>;
  private _ready: BehaviorSubject<boolean>;
  private _generation = 0;
  private static instance?: WorkspaceContextStore;

  private constructor() {
    super();
    this._observable = new BehaviorSubject<WorkspaceContextState | null>(null);
    this._ready = new BehaviorSubject<boolean>(false);
  }

  static getInstance(): WorkspaceContextStore {
    WorkspaceContextStore.instance =
      WorkspaceContextStore.instance ?? new WorkspaceContextStore();
    return WorkspaceContextStore.instance;
  }

  /**
   * Emits `true` once the initial workspace-context load has finished,
   * whether it succeeded or failed. Route guards use this to know when the
   * context is authoritative and it is safe to enforce master/operational
   * access, instead of blocking or bouncing valid deep links while loading.
   */
  get ready(): BehaviorSubject<boolean> {
    return this._ready;
  }

  get generation(): number {
    return this._generation;
  }

  beginResolution(): number {
    this._generation += 1;
    this._ready.next(false);
    return this._generation;
  }

  isCurrentGeneration(generation: number): boolean {
    return this._generation === generation;
  }

  markReady(): void {
    if (!this._ready.getValue()) {
      this._ready.next(true);
    }
  }

  failClosed(generation: number): boolean {
    if (!this.isCurrentGeneration(generation)) return false;
    this._observable.next(null);
    this._ready.next(false);
    return true;
  }

  reset(): void {
    this._generation += 1;
    this._observable.next(null);
    this._ready.next(false);
  }
}
